<div class="container">
  <header class="page-header-title" i18n>Builder overview</header>
  @if (totalCount !== null) {
    <p class="page-sub-header" i18n>{totalCount, plural, 0 {No builders available} 1 {{{totalCount}} builder available} other {{{totalCount}} builders available}}</p>
  }
  <article class="content-card-background">
    <section class="header-row">
      <div class="button-group-border">
        <div class="button-group">
          <div
            class="group-button"
            [class.selected]="imageTypeSelection$.value === null"
            (click)="imageTypeSelection$.next(null)">
            <a i18n>All</a>
          </div>
          <div
            class="group-button"
            [class.selected]="imageTypeSelection$.value === ImageTypeEnum.GIF"
            (click)="imageTypeSelection$.next(ImageTypeEnum.GIF)">
            <a i18n>GIF</a>
          </div>
          <div
            class="group-button"
            [class.selected]="imageTypeSelection$.value === ImageTypeEnum.Video"
            (click)="imageTypeSelection$.next(ImageTypeEnum.Video)">
            <a i18n>Video</a>
          </div>
          <div
            class="group-button"
            [class.selected]="imageTypeSelection$.value === ImageTypeEnum.Image"
            (click)="imageTypeSelection$.next(ImageTypeEnum.Image)">
            <a i18n>Image</a>
          </div>
        </div>
      </div>

      <div class="table-header-input-wrapper grow">
        <input type="text" i18n-placeholder placeholder="Click here to search" [formControl]="search">
        <i class="fas fa-search input-icon"></i>
      </div>

      <div class="header-right">
        <select [formControl]="first" class="paging-select">
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>
    </section>

    @if (loading === true) {
      <h4 class="loading" i18n>
      Loading builder configurations...
    </h4>
    }

    @if (builderOptions.length === 0 && loading === false) {
      <h4 class="no-templates" i18n>
      No builder configurations found.
    </h4>
    }


    @for (builderOption of builderOptions; track builderOption; let isLast = $last) {
      <div class="template-row" [class.no-bottom-line]="isLast && pageCount <= 1">
        <a class="template-img-wrapper" [routerLink]="['/builder', 'new', builderOption.id]">
          <div class="template-img-container">
            <img
              class="template-img"
              [src]="builderOption.thumbnail"
              alt="builder config thumbnail"
              i18n-alt>
          </div>
          <div class="image-icon-border">
            @if (builderOption.type === ImageTypeEnum.Video) {
              <i class="fas fa-play-circle image-icon"></i>
            }
            @if (builderOption.type === ImageTypeEnum.Image) {
              <i class="far fa-image-polaroid image-icon"></i>
            }
            @if (builderOption.type === ImageTypeEnum.GIF) {
              <img src="assets/icons/gif.svg" class="image-icon" alt="GIF" i18n-alt>
            }
          </div>
        </a>
        <section class="template-details">
          <a class="clean-link" [routerLink]="['/builder', 'new', builderOption.id]">
            <h2>{{ builderOption.title }}</h2>
          </a>
          <p class="template-date" i18n>Created on: {{ builderOption.created | date:'longDate' }}</p>
          <p class="content-text" [innerHTML]="builderOption.description"></p>
          <div class="clearfix"></div>
          <div class="button-wrapper">
            <a class="skideo-flat-button green img-left clean-link" [routerLink]="['/builder', 'new', builderOption.id]">
              <img src="assets/icons/arrow-circle-chevron-right.svg" alt="">
              <span class="button-text" i18n>Create template</span>
            </a>
          </div>
        </section>
      </div>
    }

    @if (pageCount > 1) {
      <div class="footer-pager-row">
        <button (click)="previousPage()" [disabled]="offset.value <= 1" class="skideo-flat-button black img-left">
          <i class="fas fa-arrow-left next-page-button-icon"></i>
          <ng-container i18n>Previous page</ng-container>
        </button>
        <select [formControl]="offset">
          @for (number of pages; track number) {
            <option [ngValue]="number + 1">{{ number + 1 }}</option>
          }
        </select>
        <button (click)="nextPage()" [disabled]="offset.value >= pageCount" class="skideo-flat-button black img-right">
          <ng-container i18n>Next page</ng-container>
          <i class="fas fa-arrow-right next-page-button-icon"></i>
        </button>
      </div>
    }
  </article>
</div>